/* eslint-disable react/prop-types */
import React from "react";
import { isFeatureEnabled } from "../feature-flags/utils";
import LegacyPages from "./LegacyPages";
import LazyPages from "./LazyPages";

const LAZY_ROUTING_FLAG = "15999-lazy-routing" as const;

const Pages = (props) => {
  if (isFeatureEnabled(LAZY_ROUTING_FLAG)) {
    return <LazyPages {...props} />;
  }
  return <LegacyPages {...props} />;
};

export default Pages;
